import { PAGINGATION_DEFAULT } from '@const/pagination'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchArticleList, fetchArticleSingle } from './asyncAction'

const initialState: TArticleManagementDetail.TState = {
  articleList: {
    data: [],
    ...PAGINGATION_DEFAULT
  },
  isFetchingArticleList: true,
  articleDetail: {
    data: {
      category: {
        id: '',
        name: ''
      },
      content: '',
      displayOrder: 1,
      foods: [],
      id: '',
      isPublish: false,
      managerId: '',
      provinces: [],
      stores: [],
      thumbImage: '',
      title: '',
      updatedAtUtc: ''
    }
  }
}

const articleManagementSlice = createSlice({
  name: 'articleManagement',
  initialState,
  reducers: {
    setChecked (state, action: PayloadAction<{ index: number, isChecked: boolean }>) {
      const { index, isChecked } = action.payload
      state.articleList.data[index].isChecked = isChecked
    },
    setFieldInArticleDetails (
      state,
      action: PayloadAction<{ value: any, field: keyof TArticleManagementDetail.InputField }>
    ) {
      const { value, field } = action.payload
      // @ts-ignore
      state.articleDetail.data[field] = value
    },
    setIsPublish (state, action: PayloadAction<boolean>) {
      state.articleDetail.data.isPublish = action.payload
    },
    setHtmlEditor (state, action: PayloadAction<string>) {
      state.articleDetail.data.content = action.payload
    }
  },
  extraReducers: builder => {
    builder
      .addCase(fetchArticleList.fulfilled, (state, action: PayloadAction<TArticleManagementDetail.TState['articleList']>) => {
        if (!action.payload?.data) return
        const withIsChecked = action.payload.data.map(item => ({ ...item, isChecked: false }))
        state.articleList = {
          ...action.payload,
          data: withIsChecked
        }
        state.isFetchingArticleList = false
      })
      .addCase(fetchArticleList.pending, state => {
        state.isFetchingArticleList = true
      })
    builder
      .addCase(fetchArticleSingle.fulfilled, (state, action: PayloadAction<TArticleManagementDetail.TState['articleDetail']>) => {
        if (!action.payload) return
        state.articleDetail = action.payload
      })
  }
})

export * from './asyncAction'

export const {
  setChecked,
  setFieldInArticleDetails,
  setIsPublish,
  setHtmlEditor
} = articleManagementSlice.actions

export const articleManagementReducer = articleManagementSlice.reducer
